import { actionTypes } from "../actions/companies";

const variable = (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_COMPANY_USERS:
      return action.payload;
    default:
      return state;
  }
};

export default variable;